export const RESTO365_RSS = 'RESTO365_RSS'

export const RESTO365_RSS_MASTER_TASKS = `${RESTO365_RSS}/getMasterTasks`

export const RESTO365_RSS_RESTAURANT_TASKS_BY_RESTAURANT_ID = `${RESTO365_RSS}/getRestaurantTasksByRestaurantId`

export const RESTO365_RSS_RESTAURANT_TASKS_SCHEDULE = `${RESTO365_RSS}/getRestaurantTasksSchedule`

export const RESTO365_RSS_RESTAURANT_TASKS_CREATE = `${RESTO365_RSS}/submitRssRestaurantTasks`

export const RESTO365_RSS_RESTAURANT_TASKS_SCHEDULE_CREATE = `${RESTO365_RSS}/submitRestaurantTasksSchedule`

export const RESTO365_RSS_RESTAURANT_TASKS_SCHEDULE_UPDATE = `${RESTO365_RSS}/updateRestaurantTasksSchedule`

export const RESTO365_RSS_RESTAURANT_SCHEDULED_TASKS = `${RESTO365_RSS}/submitRestaurantScheduledTasks`

export const RESTO365_RSS_RESTAURANT_SCHEDULED_TASKS_BULK_UPDATE = `${RESTO365_RSS}/submitBulkUpdateRssRestaurantScheduledTasks`

export const RESTO365_RSS_RESTAURANT_SCHEDULED_TASKS_BULK_UPDATE_STATUS = `${RESTO365_RSS}/submitBulkUpdateRssRestaurantScheduledTasksStatus`

export const RESTO365_RSS_INITIAL_STATE = `${RESTO365_RSS}/initialStateRSS`

export const RESTO365_RSS_RESTAURANT_TASKS_UPDATE = `${RESTO365_RSS}/updateRssRestaurantTasks`

export const RESTO365_RSS_RESTAURANT_TASKS_DELETE = `${RESTO365_RSS}/deleteRssRestaurantTasks`

export const RESTO365_RSS_RESTAURANT_TASKS_RESTORE = `${RESTO365_RSS}/restoreRssRestaurantTasks`

export const RESTO365_RSS_RESTAURANT_TASKS_SUBMISSIONS_BY_RESTAURANT_ID = `${RESTO365_RSS}/restaurantTaskSubmissionsByRestaurantId`

export const RESTO365_RSS_RESTAURANT_TASKS_SUBMISSIONS_BY_ID = `${RESTO365_RSS}/restaurantTaskSubmissionsById`
